<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

defineProps<{
  open: boolean;
  title: string;
  description: string;
  btnText?: string;
  btnColor: string;
  busy?: boolean;
  busyText?: string;
}>();

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
  (e: "action", event: MouseEvent): void;
}>();

function handleCancel() {
  emit("update:open", false);
}

function handleAction(event: MouseEvent) {
  emit("action", event);
}
</script>

<template>
  <AlertDialog
    :open="open"
    @update:open="(v) => emit('update:open', busy ? true : v)"
  >
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ title }}</AlertDialogTitle>
        <AlertDialogDescription>
          {{ description }}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel
          :disabled="busy"
          @click="handleCancel"
        >
          Cancel
        </AlertDialogCancel>
        <AlertDialogAction
          :disabled="busy"
          :class="cn('text-white', btnColor)"
          @click="handleAction"
        >
          {{ busy ? (busyText ?? "Working...") : (btnText ?? "Confirm") }}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
